import React, { useEffect, useState } from "react";
import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axiosAPI } from "../../../Components/AxiosComponents/Axios";
import { encryptId } from "../../../Components/CryptoComponent";

function DocumentList() {
  const navigate = useNavigate();
  const columns = [
    { field: "DC_Id", label: "#" },
    { field: "DC_Name", label: "Document Type" },
    { field: "DC_Status", label: "Status" },
  ];

  const [searchParams] = useSearchParams();


  const actions = [
    {
      icon: Edit,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.DC_Id));

        navigate(
          `/DocumentLookup/Edit/${encrypted}?${searchParams.toString()}`
        );
      },
      color: "warning",
    },
  ];
  return (
    <DynamicTable
      columns={columns}
      dataAPI={`/DocChecklist/list`}
      actions={actions}
      title={`Document Type`}
      linkvalue={`/DocumentLookup/Add?${searchParams.toString()}`}
    />
  );
}

export default DocumentList;
